export default __webpack_public_path__ + "files/thumbnail-2af79b4d35d884d94562535925080881.png";